document.addEventListener('click', function(e){
  const a = e.target.closest('a.js-slow-scroll[href^="#"]');
  if(!a) return;

  const id = a.getAttribute('href');
  const target = document.querySelector(id);
  if(!target) return;

  e.preventDefault();

  const headerOffset = 120; // 90-160 arası dene
  const targetY = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
  const startY = window.pageYOffset;
  const diff = targetY - startY;

  const duration = 1250; // ms (daha yavaş istiyorsan 1000 yap)
  const start = performance.now();

  function easeInOutCubic(t){
    return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3)/2;
  }

  function step(now){
    const elapsed = now - start;
    const t = Math.min(elapsed / duration, 1);
    const eased = easeInOutCubic(t);
    window.scrollTo(0, startY + diff * eased);
    if(t < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
});